export enum ReleaseCycle {
  ALPHA = "ALPHA",
  BETA = "BETA",
  STABLE = "STABLE",
}

export type DeliveryMethod = "manual" | "email" | "hybrid"

export interface IngestionConfig {
  deliveryMethods: DeliveryMethod[]
  validationSchema: {
    requiredColumns: string[]
    optionalColumns?: string[]
    columnTypes?: Record<string, "string" | "number" | "date" | "boolean">
    customValidators?: Array<{ column: string; validator: string }>
  }
  emailConfig?: {
    jobTypePattern: string
    allowedFileTypes: string[]
    maxFileSize: number
  }
}

export type ConnectorMetadata = {
  visibleToCompanyIds?: string[]
  errors?: string[]
  isBeta: boolean
  ingestionConfig?: IngestionConfig
}

export type ConnectorDto = {
  id: string
  name: string
  icon: string
  category: string[]
  authStrategy: string
  releaseCycle: ReleaseCycle
  config: object
  schema: object
  metadata: ConnectorMetadata
  allowMultipleConnections?: boolean
  requiresOAuthPreConfig?: boolean
  createdAt: string
  updatedAt: string
  scopeVersion?: number
}
